import Vue from 'vue'
import Vuex from 'vuex'

import {popupKeyData,maxName,minName} from './key.js';

Vue.use(Vuex)

function createPopupNameState(){
  const obj = {};
  
  Object.values(popupKeyData).forEach((val)=>{
    const max = `${val}Visible`;
    const min = `${val}MinVisible`;
    obj[max] = false;
    obj[min] = false;
  })
  return obj;
}

export default new Vuex.Store({
  state: {
    ...createPopupNameState(),
    popupCount: 0,//可拖拽弹窗显示个数
    popupZIndex: 1500,//z-index
  },
  mutations: {
    popupOpen(state){
      state.popupCount += 1;
    },
    popupClose(state){
      if(state.popupCount===0) return;
      state.popupCount -= 1;
    },
    //可拖拽弹窗的z-index
    changePopupZIndex(state){
      state.popupZIndex += 1;
    },
    //打开可拖拽弹窗
    openPopupVisible(state,key){
      state.popupZIndex += 1;

      if(!popupKeyData.hasOwnProperty(key)){
        console.error('无效的key');
        return;
      }
      const max = maxName(key);
      const min = minName(key);
      if(state[min]){
        state[min] = false;
      }
      if(!state[max]){
        state[max] = true;
      }
    },
    //关闭可拖拽弹窗
    closePopupVisible(state,payloadkey){
      const { key, type = 'max' } = payloadkey;
      if(!popupKeyData.hasOwnProperty(key)){
        console.error('无效的key');
        return;
      }
      if(type==='min'){
        const min = minName(key);
        state[min] = true;
      }else{
        const max = maxName(key);
        state[max] = false;
      }
    }
  },
  actions: {},
  modules: {}
})
